import React, { useContext, useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import myFunctions from '../../../myFunctions';
import { CurrentSingleContext } from '../../MyContexts/CurrentSingle_Context';
import { RestContext } from '../../MyContexts/Rest_Context';
import SelectImgComp from '../../MySections/ImagesSetter/SelectImgComp';
import SelectImgDelay from '../../MySections/ImagesSetter/SelectImgDelay';
import RichTextComp from '../../MySections/TextEditor/RichText';

const SectItmBtn2Effects = (props) => {
    const [currentSingle, setCurrentSingle] = useContext(CurrentSingleContext);

    const [btn2Color, setBtn2Color] = useState(currentSingle.btn2Color);
    const [btn2ForeColor, setBtn2ForeColor] = useState(currentSingle.btn2ForeColor);
    const [btn2Effect, setBtn2Effect] = useState(currentSingle.btn2Effect);
    const [btn2delay, setBtn2delay] = useState(currentSingle.btn2delay);
    const [btn2duration, setBtn2duration] = useState(currentSingle.btn2duration);


    useEffect(() => {

    }, [])
    return (
        <>
            <div className={"col-md-6 mb-2 onRight"}>
                <div className={"fullRow"}>
                    <div className={"col-md-4 mb-2 onRight"}>
                        <label>צבע כפתור</label>
                        <div className={"input-group"}>
                            <input type={"text"} className={"form-control"} id={"validationCustom02"} placeholder={"#fffff"} value={btn2Color} style={{ direction: "ltr" }}
                                onChange={(e) => { currentSingle.btn2Color = e.target.value; setBtn2Color(e.target.value) }} required />

                        </div>
                    </div>
                    <div className={"col-md-4 mb-2 onRight"}>
                        <label>צבע טקסט כפתור</label>
                        <div className={"input-group"}>
                            <input type={"text"} className={"form-control"} id={"validationCustom052"} placeholder={"#fffff"} value={btn2ForeColor} style={{ direction: "ltr" }}
                                onChange={(e) => { currentSingle.btn1ForeColor = e.target.value; setBtn2ForeColor(e.target.value) }} required />

                        </div>
                    </div>
                    <div className={"col-md-4 mb-2 onRight"}>
                        <label>אפקט</label>
                        <div className={"input-group"}>
                            <select defaultValue={btn2Effect} style={{ direction: "ltr" }}
                                onChange={(e) => { currentSingle.btn2Effect = e.target.value; setBtn2Effect(e.target.value) }}>

                                {myFunctions.animateList().map((itm, indx) => {
                                    return (
                                        <option key={indx}>
                                            {itm}
                                        </option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                </div>
                <div className={"fullRow"}>
                    <div className={"col-md-6 mb-2 onRight"}>
                        <label>Duration (0-5)</label>
                        <div className={"input-group"}>
                            <input type={"number"} max={5} min={0} className={"form-control"} id={"validationCustom02"} placeholder={""} value={btn2duration} style={{ direction: "ltr" }}
                                onChange={(e) => { currentSingle.btn2duration = e.target.value; setBtn2duration(e.target.value) }} required />

                        </div>
                    </div>
                    <div className={"col-md-6 mb-2 onRight"}>
                        <label>Delay</label>

                        <div className={"input-group"}>
                            <SelectImgDelay currentDelay={btn2delay ? btn2delay : ""}
                                theFunction={(fUrl) => { currentSingle.btn2delay = fUrl; setBtn2delay(fUrl) }} />

                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default SectItmBtn2Effects;